// extracted by mini-css-extract-plugin
export var copy = "descriptiveCardLink-module--copy--1bec6";
export var description = "descriptiveCardLink-module--description--7138f";
export var descriptiveCard = "descriptiveCardLink-module--descriptive-card--a278c";
export var hasCarrot = "descriptiveCardLink-module--hasCarrot--c4e3c";
export var headline = "descriptiveCardLink-module--headline--0311a";
export var image = "descriptiveCardLink-module--image--a358c";
export var imageWrapper = "descriptiveCardLink-module--image-wrapper--e1c18";
export var learnMoreButton = "descriptiveCardLink-module--learnMoreButton--aed00";
export var scaleHeadlineFont = "descriptiveCardLink-module--scale-headline-font--1814e";
export var title = "descriptiveCardLink-module--title--7491c";
export var titleContainer = "descriptiveCardLink-module--titleContainer--bf30e";